import { EmptyState } from "@elit-hair/elit-ui";
import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

import { PrpSessionsCards } from "@/pages/home/components/prp-sessions-cards";
import { useClinic } from "@/providers/hooks/use-clinic";

function SessionsPage() {
    const { t } = useTranslation();
    const { selectedClinic } = useClinic();

    // Show PRP Sessions cards when a clinic is selected, otherwise show message
    if (selectedClinic) {
        return <PrpSessionsCards clinicId={selectedClinic} />;
    }

    return (
        <div className="w-full h-full flex items-center justify-center">
            <EmptyState title={t("select_clinic_to_view_sessions")} />
        </div>
    );
}

export const Route = createFileRoute("/")({
    component: SessionsPage,
});
